import React, { useContext, useEffect, useRef, useState } from 'react';
import { Alert, Form, Select, Spin } from 'antd';
import { BlockOutlined } from '@ant-design/icons';
import Editor from '@kehila/react-page-editor';
import FormPlugin, { FormFieldPath } from './index';
import { cellPlugins } from '../plugins/cellPlugins';
import {t} from "@lingui/core/macro"

export default (formPlugin, namespace) => {
    const blocks = formPlugin.formData?.blocks || []

    return {
        Renderer: (props) => {

            const formFieldPath=useContext(FormFieldPath)


            if (props.remove) {
                formPlugin.onAddFormPlugin(props, props.nodeId, props.pluginConfig.id)
            }
            const [formBlock, setFormBlock] = useState(null)

            const {data} = props

            const blockId = data.blockId
            //console.log("blockId", blockId)


            const getFormBlock=async ()=>{
                const request=await fetch(formPlugin.BASE_URL+"/forms/block/"+blockId)
                if(request.ok){
                    const response=await request.json()
                    if(response.data){
                        setFormBlock(response.data)
                    }
                }
            }

            useEffect(() => {
                    if(blockId){
                        getFormBlock()
                    }
            },[blockId])


            if (!blockId) {
                if (!props.isPreviewMode && !props.readOnly) {
                    return (
                        <Alert showIcon type={"warning"} message={"Veuillez choisir un block."}/>
                    )
                }
                return null
            }

            //console.log(props)


            //console.log("formBlock",formBlock)
            if(!formBlock){
                return null
            }



            //console.log("formFieldPath",formFieldPath.path)

            return (
                <div>
                    <FormEditorRender
                        valuesPath={formFieldPath.path}
                        baseFormPlugin={formPlugin}
                        form={formBlock}
                        lang={props.lang}
                    />
                </div>
            )
        },
        namespace: namespace,
        id: 'form-block' + namespace,
        title: t`Module de Formulaire`,
        description: t`Element de formulaire utilisable.`,
        icon: <BlockOutlined/>,
        iconColor: "#F39C12",
        version: 1,
        hideInMenu: formPlugin.formData.type !== "COMPLEX",
        controls: {
            type: 'custom',
            Component: Controls
        }
    }


    function Controls(props) {

        const {data, onChange} = props

        const [show, setShow] = useState(true)
        const refreshForm = () => {
            setShow(false)
            setTimeout(() => setShow(true), 100)
        }
        useEffect(() => {
            refreshForm()
        }, [props.lang, props.nodeId, props.device])

        if (!show) {
            return null
        }

        return (
            <div>
                <Form.Item label={"Block Form"}>
                    <Select placeholder={"Block"} value={data.blockId} onChange={(v) => onChange({blockId:v})}>
                        {blocks.map(i => (
                            <Select.Option key={i} value={i.id}>{i.name}</Select.Option>
                        ))}
                    </Select>
                </Form.Item>
            </div>
        )
    }
}





const FormEditorRender = ({ form, lang, onChange, baseFormPlugin,valuesPath }) => {
    const [loading, setLoading] = useState(true);
    const [plugins, setPlugins] = useState([]);
    const [_, _forceUpdate] = useState(null)

    const formPluginRef = useRef(null);

    const forceUpdate=()=>{
        _forceUpdate(new Date().getTime())
    }

    const onBaseValuesChange=(e)=>{
        const _values=e.detail
        let subValues=valuesPath.reduce((acc, key) => acc?.[key], _values);
        //console.log("onBaseValuesChange",subValues)

        formPluginRef.current.setFormValues(subValues)
        formPluginRef.current.checkConditions()
    }

    useEffect(() => {
        initForm();
        baseFormPlugin.on("formValuesChanges",onBaseValuesChange)

        return () => {
            baseFormPlugin.off("formValuesChanges",onBaseValuesChange)
        }
    }, []);

    const initForm = async () => {
        let content = null;
        if (form?.content) {
            content = JSON.parse(form.content);
        }

        const plugin = new FormPlugin(null, form, content, null, true);
        const pluginList = plugin.getPlugins(cellPlugins);
        plugin.setOrg(baseFormPlugin.org);
        plugin.setEditor({forceUpdate:forceUpdate})

        formPluginRef.current = plugin;

        //console.log("formPluginRef.current",formPluginRef.current)

        setPlugins(pluginList);
        setLoading(false);
    };

    const handleChange = (v) => {
        const plugin = formPluginRef.current;
        if (!plugin) return;
        plugin.setTree(v);
        plugin.checkFormPlugins();
        onChange?.(v);
    };

    let editorContent = null;
    if (form?.content) {
        editorContent = JSON.parse(form.content);
    }

    return (
            <div style={{ width: '100%' }}>
                {loading ? (
                    <Spin spinning={true} />
                ) : (
                    <Editor
                        cellPlugins={plugins}
                        value={formPluginRef.current?.hookValueEditor(editorContent)}
                        onChange={handleChange}
                        cellSpacing={{ x: 50, y: 0 }}
                        readOnly
                        lang={lang}
                    />
                )}
            </div>
    );
};

